export default "__VITE_ASSET__71da4002__"